export default "__VITE_ASSET__DxQG4Xyi__"